export default "__VITE_ASSET__90b4da89__"